// src/pages/Profile/index.tsx
import React from 'react'
import {useProfileController} from './ProfileController'
import {ProfileView} from './ProfileView'
// import {ProfileView} from './ProfileView'

const ProfilePage: React.FC = () => {
    const controller = useProfileController()
    return <ProfileView {...controller} />
}

export default ProfilePage